import React, { type ReactNode } from "react"
import "./Label.scss"

type LabelProps = {
  children: ReactNode
  className?: string[]
  style?: React.CSSProperties
}

const Label = ({ children, className = [], style = {} }: LabelProps) => {
  let classNames = ["prime-label", ...className]
  return (
    <div
      className={classNames.join(" ")}
      style={style}
    >
      {children}
    </div>
  )
}

export default Label
